import { LabelProps } from '@trinsly/common/src/components/atoms/label'
import { SelectProps } from '@trinsly/common/src/components/molecules/select'
import SelectInput from '@trinsly/common/src/components/molecules/select-input'
import usePageableState from '@trinsly/common/src/hooks/use-pageable-state'
import useGetCompanies from 'api-hooks/use-get-companies'
import ProspectType from 'types/prospect-type'

type SelectCompanyProps = {
  label: LabelProps['children']
  error?: string
  required?: boolean
} & Omit<
  SelectProps<ProspectType['employments'][number]['companyAttributes']>,
  'itemRender' | 'options' | 'pending'
>

function SelectCompany(props: SelectCompanyProps) {
  const { pageable, setSearch } = usePageableState({
    page: 1,
    perPage: 999,
  })
  const { data: companies, pending: pendingCompanies } =
    useGetCompanies(pageable)

  return (
    <SelectInput
      {...props}
      options={companies}
      pending={pendingCompanies}
      itemRenderer={(item) => item.name}
      onInputChange={(value) => setSearch(value)}
      filterWith={({
        inputValue,
        option,
      }: {
        inputValue: string
        option: ProspectType['employments'][number]['companyAttributes']
      }) => {
        return option?.name
          ?.toLowerCase?.()
          .includes?.(inputValue?.toLowerCase?.())
      }}
    />
  )
}

export default SelectCompany
